// extracted by mini-css-extract-plugin
export var alignCenter = "_7o-d";
export var bannerShown = "_7o-6";
export var buttonContent = "_7o-0";
export var cardList = "_7o-1";
export var centerContent = "_7o-2";
export var chevron = "_7o-3";
export var closePanelButton = "_7o-k";
export var conversationContextContainer = "_7o-l";
export var conversationDetailContainer = "_7o-4";
export var detailWrapper = "_7o-7";
export var dropdownButton = "_7o-e";
export var dropdownTitle = "_7o-9";
export var fullHeight = "_7o-5";
export var hidden = "_7o-a";
export var icon = "_7o-b";
export var mergeSuggestionWrapper = "_7o-m";
export var panel = "_7o-i";
export var portalButtonsWrapper = "_7o-c";
export var right = "_7o-j";
export var tableSummaryContainer = "_7o-8";
export var tableSummaryHeader = "_7o-g";
export var threeDotsButton = "_7o-f";
export var wide = "_7o-h";